"use client";
import React from "react";
import { navItems } from "@/src/constants/nav-items";
import AnimatedMenuItem from "@/src/components/AnimatedMenuItem";

interface DesktopMenuProps {
  openContactModal: () => void;
  onNavItemClick: (category: string) => void;
}

export function DesktopMenu({
  openContactModal,
  onNavItemClick,
}: DesktopMenuProps) {
  return (
    <ul className="menu-list hidden md:flex gap-4">
      {navItems.map((item, index) => (
        <AnimatedMenuItem
          key={item.name}
          name={item.path}
          delay={index * 100}
          onClick={() => onNavItemClick(item.path)}
        />
      ))}
      <AnimatedMenuItem
        name="Contact"
        delay={navItems.length * 100}
        onClick={openContactModal}
      />
    </ul>
  );
}
